/* eslint-disable ember/no-mixins */
import { action } from '@ember/object';
import Controller from '@ember/controller';
import PostTypes from '@linc-technologies/linced-common/enums/post-type';
import EditPostMixin from '@linc-technologies/linced-common/mixins/edit-post';

export default class EventController extends Controller.extend(EditPostMixin) {
  PostTypes = PostTypes;
  editingPost = false;

  @action
  refresh() {
    this.model.update();
  }
}
